/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Auth_Connection_Error_Retry_CountdownInputs */



/**
* | output |
* | --- |
* | "Trying again in {seconds}s" |
*
* @param {Auth_Connection_Error_Retry_CountdownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_connection_error_retry_countdown = /** @type {((inputs: Auth_Connection_Error_Retry_CountdownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Connection_Error_Retry_CountdownInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nächster Versuch in ${i?.seconds}s`)
	return /** @type {LocalizedString} */ (`Trying again in ${i?.seconds}s`)
});